// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"6":"847dc6c0","255":"ad1911d3","314":"89d8951d","367":"bb9d3f15","419":"9a8647dc","554":"4d0860e4","639":"3bed61d4","641":"20e50501","778":"27ef88cd","806":"a356e914","955":"d3d3280c"}[chunkId] + ".js";
};